import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/legacy-variables.css'
import App from './App'
import initViewportHeightFix from './utils/viewport'

// Initialize viewport fixes for mobile devices
initViewportHeightFix();

// Create a wrapper for App that reapplies the viewport fix when the app mounts
const AppWithViewportFix = () => {
  useEffect(() => {
    // Reapply on component mount to ensure it works after any React hydration
    initViewportHeightFix();
    
    // Also handle orientation changes specifically
    const handleOrientationChange = () => {
      // Add a small delay to ensure the browser has updated the viewport dimensions
      setTimeout(initViewportHeightFix, 100);
    };
    
    window.addEventListener('orientationchange', handleOrientationChange);
    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);
  
  return <App />;
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithViewportFix />
  </StrictMode>,
)
